module.exports = __webpack_public_path__ + "img/mental-bakedowns.c7eecee6.svg";